<div
    *ngFor="let i of virtualItems"
    class="list-shimmer list-shimmer-{{ i }}"
></div>
